<h6 *ngIf="showMobileBreadcrumb" id="mobileBreadcrumb" class="page-title" [ngClass]="{ 'is-scroll': scroll }">
    {{ mobileBreadcrumb | translate }}
</h6>